(function ($) {
    var videos = $('.card__video video');
    videos.each(function(i ,element){
        $(this).on('play', function(e) {
            videos.not(this).each(function() {
                this.pause()
            })
        })
    })
})(jQuery);